export const PRODUCTS_PAGE_CONTENT_PARAM = 'productsPageContent'
export const SAVE_PRODUCTS_EVENT_NAME = 'save-products'
export const SAVE_PRODUCTS_RESPONSE_EVENT_NAME = 'save-products-response'
export const SAVING_LOADER_PRESENT_EVENT_NAME = 'saving-loader-present'
